import PolicyPage from '../components/PolicyPage';

export default function RefundPolicy() {
  return (
    <PolicyPage
      title="Refund & Cancellation Policy"
      subtitle="How to cancel orders and get your money back — quickly and fairly."
      lastUpdated="15 June 2026"
      sections={[
        { id: 'summary', heading: 'Summary', body: (
          <p>Because BharatCart connects you with local kirana shops, we work harder than most marketplaces to keep both buyers and shopkeepers whole. Full refunds are issued in every clearly-eligible case, typically within <b>5 business days</b>. Refunds are always issued to the original payment method.</p>
        )},
        { id: 'cancellation-buyer', heading: 'Buyer Cancellations', body: (
          <>
            <p>You may cancel a BharatCart order <b>free of charge</b> before the shop owner marks it "Preparing" (usually within 15–30 minutes of placement).</p>
            <p>After preparation begins but before dispatch, cancellation triggers a partial refund — the shop keeps at most 30 % of the item value as a preparation charge. For made-to-order categories (hot meals, cake, etc.) this may rise to 100 %.</p>
            <p>Once dispatched, an order cannot be cancelled — please use "Return & Refund" below instead.</p>
          </>
        )},
        { id: 'cancellation-seller', heading: 'Seller Cancellations', body: (
          <p>If a shop owner cannot fulfil an order (out of stock, shop closed, KYC issue), BharatCart cancels it automatically and issues a <b>100 % refund</b> within 5 business days. You may also earn a small "sorry" credit in MandiCoins.</p>
        )},
        { id: 'returns', heading: 'Returns & Refunds', body: (
          <>
            <p>Eligible for full refund on receipt:</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Wrong item, quantity or brand delivered</li>
              <li>Damaged, spilled, broken or leaking item</li>
              <li>Expired or near-expiry consumable</li>
              <li>Missing item from a multi-item order</li>
            </ul>
            <p className="mt-2">Raise the return within <b>24 hours</b> for perishables (dairy, vegetables, bakery, hotels), <b>7 days</b> for packaged goods, and <b>15 days</b> for electronics or apparel. Use the "Request return" button on your order page or WhatsApp us at <a href="tel:+911800000000" className="text-[#0D47A1] hover:underline">+91 1800-000-000</a>.</p>
          </>
        )},
        { id: 'non-returnable', heading: 'Non-Returnable', body: (
          <ul className="list-disc list-inside space-y-1">
            <li>Custom-cut cloth, tailored garments, personalised jewellery</li>
            <li>Prescription medicines dispensed against a valid Rx</li>
            <li>Any item explicitly marked "non-returnable" on the product page</li>
            <li>Cooked / hot meals that have been consumed in part</li>
          </ul>
        )},
        { id: 'refund-timeline', heading: 'Refund Timelines', body: (
          <>
            <p>Once approved, refunds hit your original payment method within:</p>
            <ul className="list-disc list-inside space-y-1">
              <li><b>UPI / Wallets:</b> 2–5 business days</li>
              <li><b>Debit / Credit / Net-banking:</b> 5–7 business days</li>
              <li><b>Cash on Delivery:</b> refunded to a wallet you specify (Paytm, PhonePe, etc.) within 5 business days</li>
            </ul>
            <p>Delays beyond these ranges are typically caused by your bank; if a refund is stuck, email <a href="mailto:refunds@bharatcart.org" className="text-[#0D47A1] hover:underline">refunds@bharatcart.org</a> with your Razorpay reference number.</p>
          </>
        )},
        { id: 'partial', heading: 'Partial Refunds', body: (
          <p>If only some items in an order are affected, BharatCart refunds those items pro-rata. Delivery fees are refunded fully whenever <b>any</b> item is missing or damaged.</p>
        )},
        { id: 'chargebacks', heading: 'Chargebacks', body: (
          <p>Please contact us <b>before</b> raising a chargeback with your bank — we can almost always resolve it faster. Fraudulent chargebacks may lead to account suspension and legal action.</p>
        )},
        { id: 'contact', heading: 'Refund Support', body: (
          <p>Email <a href="mailto:refunds@bharatcart.org" className="text-[#0D47A1] hover:underline">refunds@bharatcart.org</a> · Call <a href="tel:+911800000000" className="text-[#0D47A1] hover:underline">+91 1800-000-000</a> · WhatsApp the same number 24×7.</p>
        )},
      ]}
    />
  );
}
